var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.375,
    height: 38,
    viewBox: "0 0 42.375 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browser_icon",
    "data-name": "browser icon",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_901",
    "data-name": "Line 901",
    x2: 39.43,
    transform: "translate(0 9.925)",
    fill: "none",
    stroke: "#466dec",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M13.046,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-7.111 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M21.56,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-11.856 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M30.074,13.039a1.33,1.33,0,1,1-1.33-1.33,1.33,1.33,0,0,1,1.33,1.33",
    transform: "translate(-16.598 -7.848)",
    fill: "#466dec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 39.375,
    height: 35,
    rx: 3,
    fill: "none",
    stroke: "#466dec",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/BrowserIcon.e5d24fa659c2def0cba4754b8c52f868.svg";
export { ForwardRef as ReactComponent };